import React from "react";
import {
    Button,
    Checkbox,
    FormControlLabel,
    Grid, makeStyles, Paper, TextField, Typography,
} from "@material-ui/core";
import LogoIcon from "../components/svg/LogoIcon";
import { useLoginForm } from "../../viewmodel/hooks/getLoginForm";
import { loginError } from "../../viewmodel/providers/login";
import { useTranslation } from "react-i18next";
import TermsAndConditions from "./TermsAndConditions";

const useStyles = makeStyles((theme) => ({
    centerHorizontal: {
        marginLeft: "auto",
        marginRight: "auto",
    },
    grid: {
        backgroundColor: theme.palette.primary.main,
        height: "100%",
    },
    text: {
        color: "#fff",
    },
    icon: {
        width: "70%",
        height: "auto",
        maxHeight: "60%",
    },
    paper: {
        backgroundColor: "unset",
    },
    form: {
        display: "flex",
        flexDirection: "column",
        margin: "20px auto",
    },
    textField: {
        "& > label": {
            color: "white",
        },
        "& > div > ::before": {
            borderColor: "white",
        },
    },
    inputColor: {
        color: "white",
    },
}));


export default function Login(): JSX.Element {
    const classes = useStyles();
    const { t } = useTranslation();
    const [state, updateLoginForm, setRememberMe, setTerms] = useLoginForm();

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        updateLoginForm(e.currentTarget.id, e.currentTarget.value);
    };

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        loginError(state.name, state.password, updateLoginForm.bind(null, "error"), state.rememberMe);
    };

    const component = state.terms ? <TermsAndConditions action={() => setTerms(false)} /> : (
        <Grid container justify="center" direction="column" className={`${classes.grid} `}>
            <Paper elevation={0} className={`${classes.centerHorizontal} ${classes.paper}`}>
                <LogoIcon />
            </Paper>
            <form className={`${classes.centerHorizontal} ${classes.form}`} noValidate autoComplete="off" onSubmit={(e) => handleSubmit(e)}>
                <TextField
                    className={`${classes.textField}`} color="secondary" id="name" label={t("login-form.name")} size="medium"
                    InputProps={{
                        classes: {
                            input: classes.inputColor,
                        },
                    }}
                    onChange={(e) => handleChange(e)}
                />
                <TextField
                    className={`${classes.textField}`} color="secondary" id="password" type="password" label={t("login-form.password")}
                    InputProps={{
                        classes: {
                            input: classes.inputColor,
                        },
                    }}
                    onChange={(e) => handleChange(e)}
                />
                <FormControlLabel
                    className={`${classes.inputColor} ${classes.centerHorizontal}`}
                    control={
                        <Checkbox
                            className={`${classes.inputColor}`}
                            checked={state.rememberMe}
                            onChange={() => setRememberMe(!state.rememberMe)}
                            name="checkedB"
                        />
                    }
                    label={t("login-form.rememberMe")}
                />
                <Button type="submit" color="secondary">
                    <Typography variant="h4" className={`${classes.centerHorizontal} ${classes.text} `}>
                        {t("login-form.login")}
                    </Typography>
                </Button>
            </form>
            <Typography variant="h5" className={`${classes.centerHorizontal} ${classes.text} `}>
                {t(state.error)}
            </Typography>
            <Typography variant="h1" className={`${classes.centerHorizontal} ${classes.text} `}>
                QUIZZERO
            </Typography>
            <Button type="submit" color="secondary" style={{ width: "minContent" }} className={`${classes.centerHorizontal}`}>
                <Typography variant="h5" className={`${classes.text} `} onClick={() => setTerms(true)}>
                    {t("login-form.terms")}
                </Typography>
            </Button>

        </Grid>
    );

    return (
        component
    );
}
